interface RoomCapacitySummaryProps {
  /** Guests seated at tables (`Room.maxCapacity`). */
  banquet: number | null | undefined;
  /** Guests standing at a reception (`Room.cocktailCapacity`). */
  cocktail: number | null | undefined;
  /** The seats the plan on screen lays out. */
  seats: number;
}

const fmt = (n: number) => n.toLocaleString('en-US');

/**
 * A room's two capacities on the floor plan — seated (banquet) and standing
 * (cocktail) — with the plan's seats measured against the seated one, since
 * that is the number a layout can run past. Says nothing when the room has
 * neither.
 */
export function RoomCapacitySummary({ banquet, cocktail, seats }: RoomCapacitySummaryProps) {
  if (banquet == null && cocktail == null) return null;
  const over = banquet != null && seats > banquet;
  return (
    <dl className="text-xs space-y-0.5" data-testid="room-capacity">
      {banquet != null && (
        <div className="flex gap-1">
          <dt className="text-gray-500">Banquet:</dt>
          <dd className="text-gray-700" data-testid="room-capacity-banquet">
            {fmt(banquet)} seated{' '}
            <span
              className={over ? 'text-amber-700 font-medium' : 'text-gray-500'}
              data-testid="room-capacity-seats"
            >
              · {fmt(seats)} {seats === 1 ? 'seat' : 'seats'} on this plan
              {over && ` — ${fmt(seats - banquet)} over`}
            </span>
          </dd>
        </div>
      )}
      {cocktail != null && (
        <div className="flex gap-1">
          <dt className="text-gray-500">Cocktail:</dt>
          <dd className="text-gray-700" data-testid="room-capacity-cocktail">
            {fmt(cocktail)} standing
          </dd>
        </div>
      )}
    </dl>
  );
}
